"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = exports.DividerCss = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
function DividerCss(type) {
    if (type === 'solid') {
        return 'border-style: solid;';
    }
    else if (type === 'dashed') {
        return 'border-style: dashed;';
    }
    else {
        return 'border-style: solid;';
    }
}
exports.DividerCss = DividerCss;
exports.Divider = styled_components_1.default.hr.attrs({
    className: 'tws-hr-divider',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder-color: ", ";\n\t", "\n"], ["\n\tborder-color: ", ";\n\t", "\n"])), globalVars_module_scss_1.default.gray3, function (props) { return DividerCss(props.type); });
exports.Divider.displayName = 'Divider';
var templateObject_1;
